import styled from "styled-components";

export const DisplayFlex = styled.div<{ alignItems?: string; flexDirection?: string }>`
  display: flex;
  align-items: ${(props) => props.alignItems || "stretch"};
  flex-direction: ${(props) => props.flexDirection || "row"};
`;
